module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("   The living and the dead: I miss them all.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—Leon Wieseltier, "), _c('i', [_vm._v("Kaddish")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("We must fight old age as we would a disease.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—The aged Cato")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("   I hear it as it was now and as it is then.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—Wallace Stegner, "), _c('i', [_vm._v("Angle of Repose")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 69
// module chunks = 0